import { type GetApplicationsQueryParams } from '@gonfalon/openapi/operations/getApplications';

import { createSuspenseQueryHook } from '../internal/createSuspenseQueryHook';
import { applications } from '../queries/applications';

/**
 * @deprecated Use `createQueryOptions` with `getApplications` and `useSuspenseQuery` directly.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const useSuspenseApplications = createSuspenseQueryHook(
  ({ params }: { params?: GetApplicationsQueryParams } = {}) => applications.list({ params }),
);
